import humps from 'humps';
import { put, select, retry, all } from 'redux-saga/effects';
import { buildGetParamsObject, reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { getDistinct, getFeedState, getSortOrder } from '../selectors/ioc';
import * as filterActions from '../actions/filters';
import * as iocActions from '../actions/ioc';
import * as actions from '../actions';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';
import {
  defaultFilters,
  defaultSorting,
  defaultPagination,
} from '../constants/ioc';
import { dropdownSelectedProfile } from '../selectors/filters';

export function* loadFilters() {
  try {
    const res = yield retry(4, 500, authClient?.Filters?.load);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_FILTERS),
        payload: humps?.camelizeKeys(res?.data()),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Your password was successfully updated!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_FILTERS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Filters was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* loadSpecificFilter({ name, dataType }) {
  try {
    const res = yield retry(4, 500, authClient?.Filters?.loadSpecific, {
      name,
      dataType,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SPECIFIC_FILTER),
        payload: humps?.camelizeKeys(res?.data()),
      });
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SPECIFIC_FILTER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Filters was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* loadTagOptions() {
  try {
    const res = yield retry(4, 500, authClient?.Filters?.loadTagOptions);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_TAG_OPTIONS),
        payload: humps?.camelizeKeys(res?.data()),
      });
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_TAG_OPTIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Tag Options was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* autoCompleteTagOptions({ tagName }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Filters?.autoCompleteTagOptions,
      {
        tagName,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.AUTO_COMPLETE_TAG_OPTIONS),
        payload: humps?.camelizeKeys(res?.data()),
      });
    } else {
      yield all([
        put({
          type: reject(types?.AUTO_COMPLETE_TAG_OPTIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Tag Options was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* loadFilterProfiles() {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadFilterProfiles);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_FILTER_PROFILES),
        payload: res?.data(),
      });
      yield put(filterActions.setOriginalFilterProfiles(res?.data()?.results));
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_FILTER_PROFILES),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Filter Profiles was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* saveFilterProfileLocally({ data }) {
  try {
    yield put({
      type: resolve(types?.SAVE_FILTER_PROFILE_LOCALLY),
      payload: data,
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Filter profile has been created.',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SAVE_FILTER_PROFILE_LOCALLY),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.SAVE_FILTER_PROFILE_LOCALLY),
        ),
      }),
    ]);
  }
}

export function* saveFilterProfile({ data, shouldApply }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.saveFilterProfile, {
      body: data,
    });
    const payload = res?.data();
    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_FILTER_PROFILE),
        payload,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Filter profile has been saved',
        }),
      );

      if (shouldApply) {
        yield put(filterActions?.applyFilters(payload?.uuid));
      }
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_FILTER_PROFILE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Saving Filter Profile was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* updateFilterProfile({ data, shouldApply }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.updateFilterProfile, {
      uuid: data?.uuid,
      body: data,
    });
    const payload = res?.data();

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_FILTER_PROFILE),
        payload,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Filter profile has been updated',
        }),
      );

      if (shouldApply) {
        yield put(filterActions?.applyFilters(payload?.uuid));
      }
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_FILTER_PROFILE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Updating Filter Profile was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* changeFilterProfileName({ uuid, name }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.changeFilterProfileName, {
      uuid: uuid,
      body: { name: name },
    });
    const payload = res?.data();

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_FILTER_PROFILE_NAME),
        payload,
      });

      let currentlySelectedFP = yield select(dropdownSelectedProfile);
      if (currentlySelectedFP) {
        currentlySelectedFP.name = payload.name;
        filterActions.changeSelectedFilterProfile(currentlySelectedFP);
      }

      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Filter profile name has been changed',
        }),
      );

      loadFilterProfiles();
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_FILTER_PROFILE_NAME),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Updating Filter Profile was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* deleteFilterProfile(filterProfile) {
  const { uuid } = filterProfile;
  try {
    const res = yield retry(4, 500, authClient?.User?.deleteFilterProfile, {
      uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_FILTER_PROFILE),
        payload: res?.data(),
      });

      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Filter profile has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_FILTER_PROFILE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Deleting Filter Profile was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}
}

export function* applyFilters({ uuid }) {
  try {
    const sortOrder = yield select(getSortOrder);
    //const pagination = yield select(getPagination);
    const pagination = defaultPagination;
    //const sorting = yield select(getSorting);
    const sorting = defaultSorting;
    //const filters = yield select(getFilters);
    const filters = defaultFilters;
    const distinct = yield select(getDistinct);
    //const tag = yield select(getTag);
    const tag = undefined;
    let firstFeedState = undefined;
    let secondFeedState = undefined;
    let currentFeedState = undefined;

    if (typeof uuid === 'string') {
      filterActions.updateFilterProfile();
    } else if (uuid?.condition_blocks?.length > 0) {
      const blocks = uuid?.condition_blocks;

      blocks.forEach((block) => {
        block.conditions.forEach((condition) => {
          // set threat ranking table type filter remotely
          if (condition.indicator === 'source_state') {
            if (firstFeedState === undefined) {
              firstFeedState = condition.value.toLowerCase();
              firstFeedState =
                firstFeedState.charAt(0).toUpperCase() +
                firstFeedState.slice(1);
            } else {
              secondFeedState = condition.value.toLowerCase();
              secondFeedState =
                secondFeedState.charAt(0).toUpperCase() +
                secondFeedState.slice(1);
            }
          }
        });
      });

      if (secondFeedState) {
        if (firstFeedState === secondFeedState) {
          yield put(iocActions.setFeedStateFilter(firstFeedState));
          currentFeedState = firstFeedState;
        } else {
          yield put(iocActions.setFeedStateFilter('All'));
          currentFeedState = 'All';
        }
      } else if (firstFeedState) {
        yield put(iocActions.setFeedStateFilter(firstFeedState));
        currentFeedState = firstFeedState;
      } else {
        yield put(iocActions.setFeedStateFilter('Feed'));
      }
    }

    yield put(
      actions?.updateIocList({
        pagination,
        filters,
        sorting,
        filterProfile: uuid,
        distinct,
        tag: tag ? tag : null,
        feed_state: currentFeedState ? currentFeedState : 'Feed',
      }),
    );
    yield put(
      actions?.paginationIocList({
        pagination,
        filters,
        sorting,
        filterProfile: uuid,
        distinct,
        tag: tag ? tag : null,
        feed_state: currentFeedState ? currentFeedState : 'Feed',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.APPLY_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.APPLY_FILTERS)),
      }),
    ]);
  }
}
